import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Wordmark } from "./Logo";
import { WA_LINK, WA_NUMBER, scrollToSection } from "@/lib/api";

export const Footer = () => (
  <footer className="relative border-t border-white/8 bg-[#030712] py-16" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <Wordmark />
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
            Jasa booking permit Rawdah 100% aman menggunakan data visa resmi. Dipercaya travel umroh dari seluruh Asia
            Tenggara.
          </p>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-5 inline-flex items-center gap-2.5 text-white"
          >
            <Phone size={16} className="text-emerald-400" />
            <span className="font-mono2 font-semibold text-lg">{WA_NUMBER}</span>
          </a>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-slate-500">Navigasi</p>
          <div className="mt-4 flex flex-col gap-2.5">
            {[
              ["Beranda", "#beranda"],
              ["Keunggulan", "#keunggulan"],
              ["Cara Kerja", "#cara-kerja"],
              ["Template Excel", "#template"],
              ["Booking", "#kontak"],
            ].map(([label, hash]) => (
              <button
                key={hash}
                onClick={() => scrollToSection(hash)}
                data-testid={`footer-link-${hash.slice(1)}`}
                className="text-left text-sm text-slate-400 hover:text-white transition-colors duration-200"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <div className="lg:col-span-4">
          <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-slate-500">Area Layanan</p>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            Indonesia • Malaysia • Singapura • Brunei Darussalam • Thailand Selatan
          </p>
          <p className="mt-4 text-sm text-slate-400">Madinah Al-Munawwarah & Jakarta, Indonesia</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="mt-4 inline-block text-sm text-sky-400 hover:text-sky-300 transition-colors duration-200">
            Portal Admin Pengelola →
          </Link>
        </div>
      </div>
      <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-slate-500">© 2026 INDORAWDAH. Seluruh hak cipta dilindungi.</p>
        <p className="text-xs text-slate-500 italic">
          "Jangan biarkan jamaah Anda tidak masuk ke taman syurga."
        </p>
      </div>
    </div>
  </footer>
);
